export const globalConfig = {
    // baseUrl: 'https://localhost:7220/api'
    // baseUrl: 'https://localhost:44335/api'
    baseUrl: (window as { [key: string]: any }).baseUrl || ''   // --Config
    // baseUrl: 'https://globatech.net/InvestAppDemoData/api'   --DemoData
  };

  export const deploymentConfig = {
    react_app_build_version: process.env.REACT_APP_BUILD_VERSION
  };
  